import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getAnswersForQuestionsPpgLvl } from 'gqlQueries/promoScoreCard';
import { promoScoreCardExpendedTable } from 'parser/promoScoreCardParser';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { count } from 'console';
import { promoScorecardGraphParser } from 'parser/promoScoreCardGraphParser';

const errorMessage: string = 'Something went wrong!';

function useFetchScoreCardExpandedGraph() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const { appConfig } = useContext(UserContext);

    const variablesRef = useRef<any>({});
    // const { appConfig } = useContext(UserContext);
    // const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);
    // const commonConfig = getConfig('commonConfig', appConfig);
    const [
        fetchScoreCardExpandedGraph,
        { data: scoreCardExpandedData, loading: scoreCardExpandedDataLoading, error: scoreCardExpandedDataError },
    ] = useLazyQuery(getAnswersForQuestionsPpgLvl, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            if (variablesRef.current.from !== 'graph' || data) return;
            const { getAnswersForQuestionsPpgLvl } = payload;
            //if data present parse it and data coming from table
            if (getAnswersForQuestionsPpgLvl && getAnswersForQuestionsPpgLvl?.data?.length > 0) {
                const parsedData = promoScorecardGraphParser(getAnswersForQuestionsPpgLvl.data, appConfig);
                setData(parsedData);
                return;
            }

            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        setData,
        data: data || null,
        fetchScoreCardExpandedGraph: (variables: any) => {
            variablesRef.current = variables.variables;
            setData(null);
            setError(null);
            setLoading(true);
            fetchScoreCardExpandedGraph(variables);
        },
    };
}

export { useFetchScoreCardExpandedGraph };
